import ShowCard from '@/components/feature/ShowCard';
import { tvShows } from '@/mocks/tvShows';

export default function LatestUpdates() {
  const latestShows = tvShows.filter((s) => s.status === 'updating').slice(0, 4);

  return (
    <section className="w-full bg-background-100">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-6">
            <div>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">
                最新更新
              </h2>
              <p className="text-sm text-foreground-400 mt-1">每日更新，追剧不等待</p>
            </div>
            <a
              href={`/category/all`}
              className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              查看全部
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
            {latestShows.map((show) => (
              <div key={show.id} data-product-shop="">
                <ShowCard show={show} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}